<template>
  <el-submenu :index="item.id" popper-class="submenu" v-if="hasChildren">
    <div slot="title" style="display:inline-block;width:100%;height:100%;cursor:pointer;" @click.stop="handleTitleClick">
      {{ item.text }}
    </div>
    <menu-item
      v-for="child in item.children"
      :key="child.id"
      :item="child"
      :on-navigate="onNavigate"
    />
  </el-submenu>
  <el-menu-item :index="item.id" v-else>
    <span>{{ item.text }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    onNavigate: {
      type: Function,
      default: null
    }
  },
  computed: {
    hasChildren() {
      return this.item.children && this.item.children.length > 0
    }
  },
  methods: {
    handleTitleClick() {
      if (this.onNavigate) {
        this.onNavigate(this.item.id)
      }
    }
  }
}
</script>
